import {space} from "../provider_api";
import ILocalDateProto = space.kenko.proto.ILocalDateProto;
import {Long} from "protobufjs";
import DayOfWeekProto = space.kenko.proto.DayOfWeekProto;


export type KensuDate = {
  year: number,
  month: number,
  date: number
}


export const toDateString = (date: KensuDate | null | undefined) => {
  if (!date) {
    return '';
  }
  
  // always in yyyy-mm-dd
  return `${date?.year}-${String(date?.month).padStart(2, '0')}-${String(date?.date).padStart(2, '0')}`
}

export const fromDateString = (dateString: string) => {
  // always in yyyy-mm-dd
  const parts = dateString.split('-')
  return {
    year: parseInt(parts[0]),
    month: parseInt(parts[1]),
    date: parseInt(parts[2])
  }
}

export const fromLocalDate = (date: ILocalDateProto | null | undefined) => {
  if (!date) {
    return null;
  }
  
  return new Date(date.year as number, date.month as number - 1, date.date as number)
}

export const shortDateFormat2 = (timestamp: number | Long | null | undefined) => {
  if (!timestamp) {
    return "Unknown";
  }

  return shortDateFormat(new Date(timestamp as number));
}

export const shortDateTimeFormat2 = (timestamp: number | Long | null | undefined) => {
  if (!timestamp) {
    return "Unknown";
  }
  
  return shortDateTimeFormat(new Date(timestamp as number));
}

export const shortDateTimeFormat = (date: Date) => {
  if (date.getTime() == 0) {
    return '';
  }
  
  return date.toLocaleString(undefined, {dateStyle: 'medium', timeStyle: 'short'});
}

export const shortDateFormat = (date: Date | null | undefined) => {
  if (!date || date.getTime() == 0) {
    return '';
  }
  
  return date.toLocaleDateString(undefined, {dateStyle: 'short'});
}

// Returns as an hour / minute string
export const timestampToTimeString = (timestampMs: number) => {
  const date = new Date(timestampMs)
  return toTimeString({hour: date.getHours(), minute: date.getMinutes()})
}

export const toTimeString = (value: { hour: number, minute: number }) => {
  return value.hour.toFixed() + ':' + value.minute.toFixed(2);
}

export const fromTimeString = (timeString: string) => {
  const split = timeString.split(':');
  return {hour: parseInt(split[0]), minute: parseInt(split[1])}
}

// This should be useMemo'd by the caller.
export const time15MinuteIntervals = (startHour: number, startMinute: number ) => {
  const values: { value: string, label: string }[] = [];
  for (let h = startHour; h < 24; h++) {
    for (let m = 0; m < 60; m += 15) {

      if (h == startHour && m <= startMinute) {
        // For 11:15 start time, ignore 11:00 and 11:15
        continue;
      }
      
      // lean on the javascript date to format the time pretty...
      const d = new Date();
      d.setHours(h);
      d.setMinutes(m);
      d.setSeconds(0);
      d.setMilliseconds(0);

      values.push({
        value: toTimeString({hour: h, minute: m}),
        label: d.toLocaleTimeString(undefined, {hour: "numeric", minute: 'numeric'})
      });
    }
  }

  return values;
}

// This is the enumeration order
export const dayOfWeekValues = [
  DayOfWeekProto.SUNDAY,
  DayOfWeekProto.MONDAY,
  DayOfWeekProto.TUESDAY,
  DayOfWeekProto.WEDNESDAY,
  DayOfWeekProto.THURSDAY,
  DayOfWeekProto.FRIDAY,
  DayOfWeekProto.SATURDAY
];

export const dayOfWeekNames: Record<DayOfWeekProto, string> = {
  [DayOfWeekProto.DAY_OF_WEEK_UNKNOWN]: 'Unknown',
  [DayOfWeekProto.SUNDAY]: 'Sunday',
  [DayOfWeekProto.MONDAY]: 'Monday',
  [DayOfWeekProto.TUESDAY]: 'Tuesday',
  [DayOfWeekProto.WEDNESDAY]: 'Wednesday',
  [DayOfWeekProto.THURSDAY]: 'Thursday',
  [DayOfWeekProto.FRIDAY]: 'Friday',
  [DayOfWeekProto.SATURDAY]: 'Saturday'
}
